import { Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import STRING_KEYS from '../../../language/keys';
import CustomTextField from '../../../components/CustomTextField';
import { style } from '../AccountInformationSection/style';
import { ValidationFields } from '../../../@types/Account';
import { accountOpenPositionStyle } from './account-open-position.style';

type AccountOpenPositionProps = {
  viewMode: ViewMode,
  maximumOpenPositions: ValidationFields,
  onValuesChange: (name: string, value: string) => void,
}
export const AccountOpenPosition = ({
  viewMode,
  maximumOpenPositions,
  onValuesChange,
}:AccountOpenPositionProps):JSX.Element => {
  const { t: translate } = useTranslation();

  return (
    <Box>
      <Typography variant="h6" sx={ accountOpenPositionStyle.Typography.sx }>
        {translate(STRING_KEYS.OPEN_POSITION_TITLE)}
      </Typography>
      <CustomTextField
        viewMode={ viewMode }
        label="Position Limit"
        variant="outlined"
        value={ maximumOpenPositions.value }
        error={ maximumOpenPositions?.error }
        name="maximumOpenPositions"
        InputLabelProps={ style.label }
        onChange={ (e) => {
          onValuesChange('maximumOpenPositions', e.target.value);
        } }
      />
    </Box>
  );
};
